import { useMemo } from "react";
import { useContext } from "react";
import { useReducer } from "react";
import { createContext } from "react";
import { logisticsReducer } from "./LogisticsReducer";
import initialLogisticsState from "./LogisticsContextExtra";

export const LogisticsContext = createContext({ ...initialLogisticsState });

export function LogisticsProvider({ children }) {
    const [state, dispatch] = useReducer(logisticsReducer, initialLogisticsState);

    //#region Normal Filters
    function setReceiptDate(value) {
        dispatch({ type: "setReceiptDate", payload: value })
    }

    function setVendorShipmentNo(value) {
        dispatch({ type: "setVendorShipmentNo", payload: value })
    }

    function setSenderName(value) {
        dispatch({ type: "setSenderName", payload: value })
    }

    function setSchoolNumber(value) {
        dispatch({ type: "setSchoolNumber", payload: value })
    }

    function setLinesLinkedSelected(value) {
        dispatch({ type: "setLinesLinkedSelected", payload: value })
    }

    function setLogisticsSavedSelected(value) {
        dispatch({ type: "setLogisticsSavedSelected", payload: value })
    }
    //#endregion

    //#region Page hidden filters
    function setReturnMarkValue(value) {
        dispatch({ type: "setReturnMarkValue", payload: value })
    }

    function setBarcodeIsLinked(value) {
        dispatch({ type: "setBarcodeIsLinked", payload: value })
    }

    function setBarcodeIsLinked() {
        dispatch({ type: "barcodeIsLinked" })
    }

    function setBarcodeIsNotLinked() {
        dispatch({ type: "barcodeIsNotLinked" })
    }

    function setExtraReceipts() {
        dispatch({ type: "extraReceipts" })
    }

    function setDisabled() {
        dispatch({ type: "disabled" })
    }
    //#endregion

    //#region Paginator
    function setPageSize(value) {
        dispatch({ type: "setPageSize", payload: value })
    }

    function setCurrentPage(value) {
        dispatch({ type: "setCurrentPage", payload: value })
    }
    //#endregion

    const contextValue = useMemo(
        () => ({
            ...state,
            // Normal Filters
            setReceiptDate,
            setVendorShipmentNo,
            setSenderName,
            setSchoolNumber,
            setLinesLinkedSelected,
            setLogisticsSavedSelected,
            // Page hidden filters
            setReturnMarkValue,
            setBarcodeIsLinked,
            setBarcodeIsNotLinked,
            setExtraReceipts,
            setDisabled,
            // Paginator
            setPageSize,
            setCurrentPage
        }),
        [state]);

    return <LogisticsContext.Provider value={contextValue}>
        {children}
    </LogisticsContext.Provider>;
}

export function useLogisticsContext() {
    return useContext(LogisticsContext);
}